import { render, staticRenderFns } from "./AmountsSettings.vue?vue&type=template&id=74ce9a74&"
import script from "./AmountsSettings.vue?vue&type=script&lang=ts&"
export * from "./AmountsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports